<template><absence-page group="medical" /></template>
<script>
import AbsencePage from './AbsencePage'
export default { name: 'PersonalCabinetMedicalReports', components: { AbsencePage } }
</script>
